import { render, staticRenderFns } from "./RecommendationCard.vue?vue&type=template&id=066f5c14&scoped=true&"
import script from "./RecommendationCard.vue?vue&type=script&lang=js&"
export * from "./RecommendationCard.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationCard.vue?vue&type=style&index=0&id=066f5c14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066f5c14",
  null
  
)

/* custom blocks */
import block0 from "./RecommendationCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VChip,VIcon})
